<template>
    <div class="post-creator">
        <textarea v-model="newPostContent" class="post-input" placeholder="What's on your mind?!"
            @keyup.enter="createPost">
        </textarea>
        <button class="post-button" :disabled="!newPostContent.trim() || isPosting" @click="createPost">
            {{ isPosting ? 'Posting...' : 'Post' }}
        </button>
    </div>
</template>
<script>
import PostService from '@/service/post.js';
export default {
    name: 'PostCreator',
    data() {
        return {
            postService: new PostService(),
            newPostContent: '',
            isPosting: false
        }
    },
    methods: {
        async createPost() {
            if (!this.newPostContent.trim()) return;

            this.isPosting = true;

            let res = await this.postService.createPost(this.newPostContent);
            if (res.error === null) {
                this.newPostContent = '';
            } else if (res.error?.status === 401) {
                this.$router.push('/');
            } else {
                console.error('Error creating post:', res.error);
            }
            this.isPosting = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.post-creator {
    /* --- layout --- */
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 80%;

    /* --- theme --- */
    background-color: black;

    .post-input {
        /* --- layout --- */
        width: 96%;
        height: 80%;
        resize: none;
        padding: 2%;
        margin-bottom: 10px;

        /* --- theme --- */
        background-color: #0a0a0a;
        border: 1px solid #333;
        border-radius: 8px;
        color: #ddd;
        font-family: 'Helvetica', 'Arial', sans-serif;
        font-size: 14px;
    }

    .post-input:focus {
        outline: none;
        border-color: #555;
    }

    .post-button {
        /* --- layout --- */
        width: auto;
        max-width: 150px;
        align-self: flex-end;
        padding: 10px 20px;
        float: right;

        /* --- theme --- */
        background-color: #1da1f2;
        color: white;
        border: none;
        border-radius: 20px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .post-button:hover:not(:disabled) {
        background-color: #1990db;
    }

    .post-button:disabled {
        background-color: #1a3950;
        cursor: not-allowed;
        opacity: 0.7;
    }
}
</style>
